import type { RouteLocationNormalized, RouteRecordRaw, Router } from "vue-router";
import { clientRouteName } from "./clientRoute";

export const clientUserRouteName = {
  //   index: "client-user-index",
  detail: "client-user-detail",
};

export const clientUserRoute: RouteRecordRaw[] = [
  //   {
  //     path: "clients/:clientId/users",
  //     name: clientUserRouteName.index,
  //     component: () => import("../presentation/views/ClientUserIndexView.vue"),
  //     meta: {
  //       title: "Client Users",
  //     },
  //   },
  {
    path: "/clients/:clientId/users/:id",
    name: clientUserRouteName.detail,
    component: () => import("../pages/ClientUserDetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "client_entity",
      breadcrumbs: (to: RouteLocationNormalized, router: Router) => {
        return [
          { path: router.resolve({ name: clientRouteName.index }).path, title: "Client" },
          { path: router.resolve({ name: clientRouteName.show, params: { id: to.params.clientId as string } }).path, title: "Detail" },
          { title: "User Detail" },
        ];
      },
    },
  },
];
